// Port of api/fuel/app/classes/insights/plays/designers.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'designers',
    insight: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var ranked = []
        var limit = detail ? 100 : 5
        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''

        var sorted = Util.queryFast(
            "SELECT group_concat(DISTINCT p.game_id) AS g," +
            ' pu.designer_name AS n,' +
            ' SUM(p.play_count) AS c,' +
            ' gp.designer_id AS p' +
            ' FROM game_designer gp, play p, game g, designer pu' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date < ' + range.end +
            ' AND gp.game_id = g.game_id' +
            ' AND p.game_id = g.game_id' +
            ' AND g.game_type = 1' +
            ' AND pu.designer_id = gp.designer_id' +
            sqlCount +
            ' GROUP BY gp.designer_id' +
            ' ORDER BY SUM(p.play_count) DESC, gp.designer_id ASC' +
            ' LIMIT 0, ' + limit
        )

        var index = Util.pluck(sorted, 'p')
        var gameIndex = Util.merge(sorted, 'g')

        if (index.length) {

            if (!gameIndex.length) gameIndex = [0]

            var sortedGames = Util.queryFast(
                'SELECT SUM(p.play_count) AS c, p.game_id AS g' +
                ' FROM play p' +
                ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
                ' AND p.play_date >= ' + range.start +
                ' AND p.play_date < ' + range.end +
                ' AND p.game_id IN(' + Util.in(gameIndex) + ')' +
                sqlCount +
                ' GROUP BY p.game_id' +
                ' ORDER BY SUM(p.play_count) DESC'
            )

            var ratings = Util.queryFast(
                'SELECT AVG(r.rating_value) AS rating, r.game_id AS game' +
                ' FROM rating r' +
                ' WHERE r.game_id IN(' + Util.in(gameIndex) + ')' +
                ' AND r.user_id IN(' + Util.in(userIndex) + ')' +
                ' GROUP BY r.game_id' +
                ' ORDER BY AVG(r.rating_value) DESC, r.game_id ASC',
                null, 'game'
            )

            var sortedGamesById = {}
            for (var si = 0; si < sortedGames.length; si++) {
                sortedGamesById[String(sortedGames[si].g)] = sortedGames[si]
            }

            for (var i = 0; i < sorted.length; i++) {
                var item = sorted[i]
                var games = []
                var applicableGames = item.g ? item.g.split(',') : []

                for (var j = 0; j < applicableGames.length; j++) {
                    var gid = applicableGames[j]
                    if (sortedGamesById[gid]) {
                        games.push({
                            id: sortedGamesById[gid].g,
                            rating: ratings[sortedGamesById[gid].g] ? parseFloat(ratings[sortedGamesById[gid].g].rating) : '-'
                        })
                    }
                }

                games = games.slice().sort(function(a, b) {
                    var ar = (a.rating === '-') ? 0 : a.rating
                    var br = (b.rating === '-') ? 0 : b.rating
                    return ar !== br ? br - ar : a.id - b.id
                })

                for (var k = 0; k < 3 && k < games.length; k++) {
                    this._references.games.push(games[k].id)
                }

                ranked.push({
                    id: item.p,
                    name: item.n,
                    count: item.c,
                    games: games.slice(0, 3),
                    gamesCount: applicableGames.length
                })
            }

        }

        return {
            designers: ranked
        }

    }
})
